import React from 'react'
import styles from './Footer.module.css'
import { useAbTestGtm } from '../../../hooks/useAbTestGtm'

const Footer = () => {
    const { dataClickLabel, dataViewLabel } = useAbTestGtm()
    return (
        <footer className={styles.instaFooter} data-view-label={dataViewLabel('FT_Area')}>
            <small>Copyright &copy; 2024 foodsLabo by cuolega All rights reserved.</small>
            <div>
                <a href="https://cuolega.co.jp/privacy/" data-click-label={dataClickLabel('FT_Area_プライバシーポリシー')}>プライバシーポリシー</a>
                <a href="https://cuolega.co.jp/terms/" data-click-label={dataClickLabel('FT_Area_利用規約')}>利用規約</a>
                <a href="https://cuolega.co.jp/profile/" data-click-label={dataClickLabel('FT_Area_会社概要')}>会社概要</a>
            </div>
        </footer>
    )
}

export default Footer
